import * as React from "react";
import { useContext } from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import { FieldWrapper } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import Row from "../../../../../Layout/PageGrid/Row";
import Col from "../../../../../Layout/PageGrid/Col";
import TextInput from "../../../../../Layout/Inputs/TextInput";
import { DestinationName } from "../FtlRouteHeader/DestinationName";
import { SharedClosedLoop } from "./SharedClosedLoop";
import { Equipment } from "./Equipment";
import { LaunchClassification } from "./LaunchClassification";
import { ControlType } from "./ControlType";
import { ContainerType } from "./ContainerType";
import { ContingencyPlanningTypeInput } from "./ContingencyPlanningTypeInput";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { EditProjectContext } from "../../../EditProjectContext";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

type Props = {
  route: FtlRouteViewModel;
};

export default function RouteNumberArea({ route, isReadOnly }: Props & ReadOnlyProps) {
  const projectContextProps = useContext(EditProjectContext);

  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <Row gap="25px" marginBottom="1rem">
        <Col width="16.6%">
          <div className="k-flex-20">
            <TextInput label="Route Number" name="RouteNumber" value={route.RouteNumber} disabled />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <DestinationName route={route} isReadonly={isReadOnly} />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <TextInput
              label="Carrier Branch GSDB"
              name="CarrierGSDB"
              value={route.OriginRegion?.BranchGsdb}
              disabled
            />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <TextInput
              label="Carrier Name"
              name="CarrierName"
              value={route.OriginRegion?.CarrierName}
              disabled
            />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <TextInput
              label="Bidpack"
              name="Bidpack"
              value={route.OriginRegion?.BidPackName}
              disabled
            />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <TextInput
              label="Carrier Branch"
              name="CarrierBranch"
              value={route.OriginRegion?.BranchName}
              disabled
            />
          </div>
        </Col>
      </Row>
      <Row gap="25px" marginBottom="1rem">
        <Col width="16.6%">
          <div className="k-flex-20">
            <Equipment route={route} disabled={isReadOnly} />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <LaunchClassification route={route} disabled={isReadOnly} />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <ControlType route={route} disabled={isReadOnly} />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <SharedClosedLoop route={route} disabled={isReadOnly} />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <ContainerType route={route} disabled={isReadOnly} />
          </div>
        </Col>
        <Col width="16.6%">
          <div className="k-flex-20">
            <ContingencyPlanningTypeInput route={route} disabled={isReadOnly} />
          </div>
        </Col>
      </Row>

      <Row gap="25px" marginBottom="1rem">
        <Col width="33.2%">
          <div className="k-flex-20">
            <FieldWrapper>
              <Label>Comments</Label>
              <div className="k-form-field-wrap">
                <TextArea
                  name="Comments"
                  value={route.Comments}
                  disabled={isReadOnly || isReadOnly}
                  onChange={(event) =>
                    updateRoutePropertyOnProject(
                      "Comments",
                      event.target.value,
                      route.RouteNumber || "",
                      projectContextProps
                    )
                  }
                />
              </div>
            </FieldWrapper>
          </div>
        </Col>
      </Row>
    </div>
  );
}
